import { Icon } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import { focus, navItem, navItemBtn } from '@mage-ui/styled-system/recipes';
import { Button } from '@mantine/core';

export const NavItemBtn = ({ data, level, ...props }) => {
  const sizeLevel = level === 2 ? 2 : 1;
  const classes = navItem({ size: sizeLevel });
  const classesBtn = navItemBtn({ size: sizeLevel });

  return (
    <Button
      classNames={{
        root: cx(classesBtn.root, focus(), 'group'),
        section: classesBtn.section,
        inner: classesBtn.inner,
        label: classes.text,
      }}
      rightSection={
        <Icon
          name='arrow_downward'
          classNames={{
            root: classesBtn.iconWrapper,
          }}
        />
      }
      {...(data.expanded && { 'aria-expanded': true })}
      {...props}
    >
      {data?.fields?.title || data.text}
    </Button>
  );
};
